import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { nanoid } from 'nanoid';
import { toast } from 'react-toastify';

//Servicios
import { UserService } from '../../services/api';

//Componentes
import ProducerSignup from './ProducerSignup';
import Spinner from '../../components/spinner/Spinner';

function SignupContainer() {
    const [loader, setLoader] = useState(false);
    const [logged, setLogged] = useState(false);
    const [nroViñedoArray, setNroViñedoArray] = useState([]);

    const {
        register,
        reset,
        control,
        handleSubmit,
        watch,
        setError,
        formState,
    } = useForm();

    const onSubmit = async (usuario) => {
        // console.log(usuario);

        try {
            setLoader(true);

            delete usuario.confirmPassword;
            delete usuario.nrosViñedos;
            usuario.doc_id_tipo = parseInt(usuario.doc_id_tipo);

            let viniedos = nroViñedoArray.map((v) => {
                return v.data;
            });

            let NewUser = await UserService.create({ usuario, viniedos });

            if (NewUser) {
                setLogged(true);
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    };

    const onAddBadge = (data) => {
        let array = [...nroViñedoArray];

        array.push({ id: nanoid(), data: data.nrosViñedos });

        setNroViñedoArray(array);
        document.querySelector('.input-badge').value = '';
    };

    const onBadgeDelete = (id) => {
        let array = [...nroViñedoArray];

        let filteredArray = array.filter((data) => data.id != id);

        setNroViñedoArray(filteredArray);
    };

    return loader ? (
        <Spinner />
    ) : (
        <ProducerSignup
            functions={{
                register,
                control,
                handleSubmit,
                watch,
                setError,
                formState,
                onSubmit,
                setNroViñedoArray,
                onAddBadge,
                onBadgeDelete,
            }}
            states={{ logged, nroViñedoArray }}
        />
    );
}

export default SignupContainer;
